import Reveal from "@/components/Reveal";

export default function PageHeader({ kicker, title, intro }) {
  return (
    <section className="mx-auto max-w-[1500px] px-6 md:px-10 lg:px-14 pt-36 md:pt-44 pb-12 md:pb-20">
      <Reveal>
        <div className="eyebrow mb-6">{kicker}</div>
      </Reveal>
      <Reveal delay={120}>
        <h1
          className="display text-ink max-w-[18ch]"
          style={{ fontSize: "clamp(56px, 9vw, 160px)" }}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </Reveal>
      {intro && (
        <Reveal delay={240}>
          <p className="mt-10 max-w-2xl text-ink-800 text-lg md:text-xl leading-relaxed">
            {intro}
          </p>
        </Reveal>
      )}
    </section>
  );
}
